import { styled } from "@vitality-ds/system";

const ResultWrapper = styled("li", {
  padding: "$md",
  marginBottom: "$md",
  border: "1px solid transparent",
  borderRadius: "$default",
  "> a": {
    color: "inherit",
    textDecoration: "none",
  },
  "&:hover, &.Mui-focused": {
    borderColor: "$cyan7",
    backgroundColor: "$cyan3",
  },
  "&:active": {
    transform: "translateY(1px)",
  },
});

export default ResultWrapper;
